<template>
  <v-app id="app" >
    <v-content>
		<v-container class="fill-height clean background" fluid>			
			<v-row  no-gutters>
				<v-col class="clean" cols=12 :style="{background: $vuetify.theme.themes[theme].background}">
					<about />
				</v-col>
				
			</v-row>
			<v-row no-gutters :style="{background: $vuetify.theme.themes[theme].primary}">
				<v-col  class=" clean" cols=12>
					<links/>
				</v-col>
			</v-row>
			<v-row align="start" justify="center" no-gutters>
				<v-col  :lg="10" :xl="8" cols=12 :style="{background: $vuetify.theme.themes[theme].background}">
					<projectGrid @bingo="dialog=true"/>
				</v-col>
			</v-row>

			<v-snackbar v-model="dialog">
				Bingo!
				<v-btn color="primary" text @click="dialog = false">
					Close
				</v-btn>
			</v-snackbar>
			<v-footer width="100%" tile class="techBackground py-4 textLight--text">
				<v-col class="text-center" cols="12">
					Copyright © 2020 Magnus Lundh Haaland 
				</v-col>
			</v-footer>
		</v-container>
    </v-content>
  </v-app>
</template>

<script>
import About from './components/About';
import ProjectGrid from './components/ProjectGrid';
import Links from './components/Links';

export default {
  name: 'App',

  components: {
		About,
		ProjectGrid,
		Links
	},
	computed:{
		theme(){
		return (this.$vuetify.theme.dark) ? 'dark' : 'light'
		}
	},

  data: () => ({
		dialog : false
	}),
};
</script>

<style scoped>
.clean {
	margin:0;
	padding:0;

}
</style>
